var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9.25L16.2612 16.4088C15.8799 16.6303 15.4467 16.7469 15.0056 16.7469C14.5646 16.7469 14.1314 16.6303 13.75 16.4088L2.5 9.25",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.5H5C3.61929 5.5 2.5 6.61929 2.5 8V23C2.5 24.3807 3.61929 25.5 5 25.5H25C26.3807 25.5 27.5 24.3807 27.5 23V8C27.5 6.61929 26.3807 5.5 25 5.5Z",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a61b93c74f8dc7426c76e388bb5f9cbc.svg";
export { ForwardRef as ReactComponent };